import React from 'react';
import { useAuth } from '../../context/AuthContext.js';

interface RoleGuardProps {
  allowedRoles: string[];
  children: React.ReactNode;
}

/**
 * RoleGuard component that conditionally renders children based on user roles
 * @param allowedRoles - Array of roles that are allowed to see the children
 * @param children - React children to render if user has allowed role
 */
export const RoleGuard: React.FC<RoleGuardProps> = ({ allowedRoles, children }) => {
  const { user } = useAuth();
  const userRoles = user?.roles || [];
  
  // If no roles specified, show to everyone
  if (!allowedRoles || allowedRoles.length === 0) {
    return <>{children}</>;
  }
  
  // Check if user has at least one of the allowed roles
  const hasAllowedRole = userRoles.some(role => allowedRoles.includes(role));
  
  // Special case: admin role can see everything
  const isAdmin = userRoles.includes('admin');
  
  return (hasAllowedRole || isAdmin) ? <>{children}</> : null;
};

export default RoleGuard;
